<template>
    <div class="XscpDrivers">
        <p v-text="$t('card_reader:prerequisites:subtitle')" />
        <span
            class="XscpDrivers-description"
            v-text="$t('card_reader:drivers:description')"
        />
        <v-alert
            v-if="showGetNewXscpVersion"
            class="XscpDrivers-alert"
            color="warning"
            variant="tonal"
        >
            {{ t('card_reader:prerequisites:new_version_warning:message') }}
        </v-alert>
        <conduent-card-reader-installation
            :cdnUrl="cdnUrl"
            :xscpVersion="xscpVersion"
            @downloadXSCP="downloadXSCP"
        />
        <v-btn
            color="primary"
            variant="flat"
            class="XscpDrivers-button"
            @click="launchXSCP"
        >
            {{ $t('card_reader:prerequisites:all_settled_button_text') }}
        </v-btn>
    </div>
</template>

<script setup>
import config from 'config'
import { computed, onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'

const emit = defineEmits(['downloadXSCP', 'launchXSCP'])

const { t } = useI18n()

const showGetNewXscpVersion = ref(false)
const xscpVersion = ref(config?.support_reader?.xscp_version ?? 'V02.01')

const cdnUrl = computed(() => process.env.VUE_APP_CDN_URL)

function downloadXSCP () {
    emit('downloadXSCP')
}

function launchXSCP () {
    emit('launchXSCP')
}

onMounted(() => {
    const installedXscpVersion = localStorage.getItem('installedXscpVersion')

    if (installedXscpVersion && installedXscpVersion !== config.support_reader.xscp_version) {
        showGetNewXscpVersion.value = true
    }
})
</script>

<style lang="scss" scoped>
@import 'globalScss';

.XscpDrivers {
    display: flex;
    flex-direction: column;
    gap: $s2;

    &-description {
        margin-bottom: $s4;
        font-size: $font-xsmall;
        color: $color-black-ultraLight;
    }

    &-alert {
        border-radius: 12px;
        font-size: $font-xsmall;
    }

    &-button {
        width: 100%;
        margin-top: $s2;
    }
}
</style>
